<template>
    <HeaderComponent />
    <ExperienceComponent />
    <PreviewPage2Component 
    title="Nuestros Servicios"
    description="Ofrecemos soluciones integrales de marketing digital para potenciar tu negocio, desde branding y redes sociales hasta desarrollo web y edición de contenido. Impulsa tu presencia online con estrategias efectivas y creativas."
    marginT="100px"
    marginB="200px"
    backgroundColor="transparent"

    />
    <FormContactComponent />
    <!-- <PreviewPageComponent title="Casos clinicos" go="/blogs" goLabel="Ver más" showQuantily="3" showQuantilyXl="2.5" showQuantilyLg="2" showQuantilyMd="1.5" showQuantilySm="1" between="50" list="" limit="8" marginB="100px" backgroundColor="transparent"/> -->
  </template>
  
  <script>
  import HeaderComponent from '../components/Header-component.vue';
  import ExperienceComponent from '../components/Experiences-component.vue';
  import FormContactComponent from '../components/FormContact-component.vue';
  import PreviewPage2Component from '../components/PreviewPage2-component.vue';
  // import PreviewPageComponent from '../components/PreviewPage-component.vue';

  export default {
    name: 'HomePage',
    components: {
      HeaderComponent,
      ExperienceComponent,
      FormContactComponent,
      PreviewPage2Component,
      // PreviewPageComponent,

    }
  }
  </script>
  
  <style scoped>
  </style>
  